import * as React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache'; // Cache with option to prepend emotion's style tag

export var cache = createCache({
  key: 'css',
  prepend: true
});
export default function StyledEngineProvider(props) {
  var injectFirst = props.injectFirst,
      children = props.children;
  return injectFirst ? /*#__PURE__*/React.createElement(CacheProvider, {
    value: cache
  }, children) : children;
}
process.env.NODE_ENV !== "production" ? void 0 : void 0;